<template>
  <div>
    <h3>
      用户
      <el-button type="primary" icon="el-icon-plus" size="small" @click="onCreate" style=" float:right">新增</el-button>
    </h3>

    <TableSearch ref="Table" ConfigPath="/Admin/Users/List" :ConfigPara="{Sex:1}" @event="tableEvent"></TableSearch>

    <!-- 扩展任务：编写插件 FormInfo.vue json化 完成增改操作-->
    <el-dialog ref="drawer" :visible.sync="dialog" v-if="dialog" width="40%">
      <FormInfo ref="FormInfo" SourcePath="Template" :ConfigPara="{Config:'demo',Key:'ID',Value:ID}" :DefaultValue="[{Key:'ID',Value:ID}]" @event="formEvent"></FormInfo>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      ID: 0,
      //定义form
    };
  },
  methods: {
    //TableSearch 自定义html所引发的事件 返回相关 html对象
    tableEvent: function (x) {
      console.log(x);
      var t = x.target.dataset;
      if (t.key == "Delete") {
        this.$confirm("确定删除?", "提示", { type: "warning" })
          .then(() => {
            this.Data.Users.Del(t.value).then((res) => {
              this.$refs.Table.getList();
            });
          })
          .catch(() => {});
      } else if (t.key == "Edit") {
        this.Data.Users.Get(t.value).then((res) => {
          this.ID = t.value;
          this.dialog = true;
        });
      }
    },
    //新增方法
    onCreate() {
      this.ID = 0;
      this.dialog = true;
    },
    //提交方法
    formEvent: function (x) {
      var t = x.target.dataset;
      if (t.key == "Submit") {
        var f = x.form;
        //保存信息
        this.Data.Users.Save(f).then((res) => {
          if (res.code == 0) {
            this.$refs.Table.getList();
            this.$message.success(res.message);
            this.dialog = false;
          }
        });
      }
    },
  },
};
</script>